/* MERRY VELA - reference layout helpers: gallery dots on the product page */
(function () {
  'use strict';
  function initDots(gallery) {
    if (gallery.getAttribute('data-dots-ready')) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    if (!track || slides.length < 2) return;
    gallery.setAttribute('data-dots-ready', 'true');
    var wrap = document.createElement('div');
    wrap.className = 'gallery__dots';
    var dots = [];
    Array.prototype.forEach.call(slides, function (s, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'gallery__dot';
      d.setAttribute('aria-label', 'Pokaż zdjęcie ' + (i + 1));
      d.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); });
      wrap.appendChild(d);
      dots.push(d);
    });
    var main = gallery.querySelector('.gallery__main');
    main.parentNode.insertBefore(wrap, main.nextSibling);
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }
  function init() {
    if (!document.body.classList.contains('template-suffix-led-light-curtain') && !document.body.classList.contains('template-suffix-szlafrok')) return;
    document.querySelectorAll('[data-gallery]').forEach(initDots);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
